module.exports = __webpack_public_path__ + "media/03.0ba270f8.mp3";